// src/app/interceptors/auth.interceptor.ts

import { HttpErrorResponse, HttpHandlerFn, HttpRequest } from '@angular/common/http';

import { inject } from '@angular/core';
import { NavController } from '@ionic/angular';
import { catchError, from, switchMap, throwError } from 'rxjs';

import { AuthService } from '../services/auth.service';

export function authInterceptor(req: HttpRequest<unknown>, next: HttpHandlerFn) {
  const authService = inject(AuthService);
  const navController = inject(NavController);

  return from(authService.waitUntilReady()).pipe(
    switchMap(() => from(authService.getToken())),
    switchMap((authToken) => {
      let request = req;

      // Añade token si existe
      if (authToken) {
        request = req.clone({
          setHeaders: {
            Authorization: `Bearer ${authToken}`,
          },
        });
      }

      return next(request).pipe(
        catchError((error: HttpErrorResponse) => {
          // Token inválido o expirado
          if (error.status === 401) {
            return from(authService.logout()).pipe(
              catchError((e) => {
                console.error(e);
                return from([null]); // Ignora el error de logout y continúa
              }),
              switchMap(() => {
                // Limpia localStorage por si acaso
                localStorage.clear();

                // Limpia sessionStorage
                sessionStorage.clear();

                // Redirige al login
                navController.navigateRoot('/login', {
                  animated: true,
                  animationDirection: 'back',
                });

                return throwError(() => error);
              }),
            );
          }

          return throwError(() => error);
        }),
      );
    }),
  );
}
